/* prettier-ignore-start */

/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file is auto-generated by TanStack Router

import { createFileRoute } from '@tanstack/react-router'

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as R404Import } from './routes/$404'
import { Route as DashboardRouteImport } from './routes/dashboard/route'
import { Route as IndexImport } from './routes/index'
import { Route as DashboardLayoutImport } from './routes/dashboard/_layout'
import { Route as DashboardLayout404Import } from './routes/dashboard/_layout/$404'
import { Route as DashboardLayoutIntegrationsRouteImport } from './routes/dashboard/_layout/integrations/route'
import { Route as AuthAuthLayoutResetPasswordRouteImport } from './routes/_auth/_authLayout/reset-password/route'
import { Route as AuthAuthLayoutLoginRouteImport } from './routes/_auth/_authLayout/login/route'
import { Route as DashboardLayoutPlacesMapViewRouteImport } from './routes/dashboard/_layout/places/map-view/route'
import { Route as DashboardLayoutGeopersonaSegmentListRouteImport } from './routes/dashboard/_layout/geopersona/segment-list/route'
import { Route as DashboardLayoutGeopersonaMapViewRouteImport } from './routes/dashboard/_layout/geopersona/map-view/route'

// Create Virtual Routes

const AuthAuthLayoutLazyImport = createFileRoute('/_auth/_authLayout')()
const DashboardLayoutSettingsRouteLazyImport = createFileRoute(
  '/dashboard/_layout/settings',
)()
const AuthAuthLayoutForgotPasswordRouteLazyImport = createFileRoute(
  '/_auth/_authLayout/forgot-password',
)()
const DashboardLayoutIntegrationsIndexLazyImport = createFileRoute(
  '/dashboard/_layout/integrations/',
)()
const DashboardLayoutPlacesMyDataRouteLazyImport = createFileRoute(
  '/dashboard/_layout/places/my-data',
)()
const DashboardLayoutIntegrationsUsersRouteLazyImport = createFileRoute(
  '/dashboard/_layout/integrations/users',
)()
const DashboardLayoutIntegrationsIntegrationTradedeskLazyImport =
  createFileRoute('/dashboard/_layout/integrations/_integration/tradedesk')()

// Create/Update Routes

const R404Route = R404Import.update({
  path: '/$404',
  getParentRoute: () => rootRoute,
} as any)

const DashboardRouteRoute = DashboardRouteImport.update({
  path: '/dashboard',
  getParentRoute: () => rootRoute,
} as any)

const IndexRoute = IndexImport.update({
  path: '/',
  getParentRoute: () => rootRoute,
} as any)

const AuthAuthLayoutLazyRoute = AuthAuthLayoutLazyImport.update({
  id: '/_auth/_authLayout',
  getParentRoute: () => rootRoute,
} as any).lazy(() =>
  import('./routes/_auth/_authLayout.lazy').then((d) => d.Route),
)

const DashboardLayoutRoute = DashboardLayoutImport.update({
  id: '/_layout',
  getParentRoute: () => DashboardRouteRoute,
} as any)

const DashboardLayoutSettingsRouteLazyRoute =
  DashboardLayoutSettingsRouteLazyImport.update({
    path: '/settings',
    getParentRoute: () => DashboardLayoutRoute,
  } as any).lazy(() =>
    import('./routes/dashboard/_layout/settings/route.lazy').then(
      (d) => d.Route,
    ),
  )

const AuthAuthLayoutForgotPasswordRouteLazyRoute =
  AuthAuthLayoutForgotPasswordRouteLazyImport.update({
    path: '/forgot-password',
    getParentRoute: () => AuthAuthLayoutLazyRoute,
  } as any).lazy(() =>
    import('./routes/_auth/_authLayout/forgot-password/route.lazy').then(
      (d) => d.Route,
    ),
  )

const DashboardLayout404Route = DashboardLayout404Import.update({
  path: '/$404',
  getParentRoute: () => DashboardLayoutRoute,
} as any)

const DashboardLayoutIntegrationsRouteRoute =
  DashboardLayoutIntegrationsRouteImport.update({
    path: '/integrations',
    getParentRoute: () => DashboardLayoutRoute,
  } as any).lazy(() =>
    import('./routes/dashboard/_layout/integrations/route.lazy').then(
      (d) => d.Route,
    ),
  )

const AuthAuthLayoutResetPasswordRouteRoute =
  AuthAuthLayoutResetPasswordRouteImport.update({
    path: '/reset-password',
    getParentRoute: () => AuthAuthLayoutLazyRoute,
  } as any).lazy(() =>
    import('./routes/_auth/_authLayout/reset-password/route.lazy').then(
      (d) => d.Route,
    ),
  )

const AuthAuthLayoutLoginRouteRoute = AuthAuthLayoutLoginRouteImport.update({
  path: '/login',
  getParentRoute: () => AuthAuthLayoutLazyRoute,
} as any).lazy(() =>
  import('./routes/_auth/_authLayout/login/route.lazy').then((d) => d.Route),
)

const DashboardLayoutIntegrationsIndexLazyRoute =
  DashboardLayoutIntegrationsIndexLazyImport.update({
    path: '/',
    getParentRoute: () => DashboardLayoutIntegrationsRouteRoute,
  } as any).lazy(() =>
    import('./routes/dashboard/_layout/integrations/index.lazy').then(
      (d) => d.Route,
    ),
  )

const DashboardLayoutPlacesMyDataRouteLazyRoute =
  DashboardLayoutPlacesMyDataRouteLazyImport.update({
    path: '/places/my-data',
    getParentRoute: () => DashboardLayoutRoute,
  } as any).lazy(() =>
    import('./routes/dashboard/_layout/places/my-data/route.lazy').then(
      (d) => d.Route,
    ),
  )

const DashboardLayoutIntegrationsUsersRouteLazyRoute =
  DashboardLayoutIntegrationsUsersRouteLazyImport.update({
    path: '/users',
    getParentRoute: () => DashboardLayoutIntegrationsRouteRoute,
  } as any).lazy(() =>
    import('./routes/dashboard/_layout/integrations/users/route.lazy').then(
      (d) => d.Route,
    ),
  )

const DashboardLayoutPlacesMapViewRouteRoute =
  DashboardLayoutPlacesMapViewRouteImport.update({
    path: '/places/map-view',
    getParentRoute: () => DashboardLayoutRoute,
  } as any).lazy(() =>
    import('./routes/dashboard/_layout/places/map-view/route.lazy').then(
      (d) => d.Route,
    ),
  )

const DashboardLayoutGeopersonaSegmentListRouteRoute =
  DashboardLayoutGeopersonaSegmentListRouteImport.update({
    path: '/geopersona/segment-list',
    getParentRoute: () => DashboardLayoutRoute,
  } as any).lazy(() =>
    import(
      './routes/dashboard/_layout/geopersona/segment-list/route.lazy'
    ).then((d) => d.Route),
  )

const DashboardLayoutGeopersonaMapViewRouteRoute =
  DashboardLayoutGeopersonaMapViewRouteImport.update({
    path: '/geopersona/map-view',
    getParentRoute: () => DashboardLayoutRoute,
  } as any).lazy(() =>
    import('./routes/dashboard/_layout/geopersona/map-view/route.lazy').then(
      (d) => d.Route,
    ),
  )

const DashboardLayoutIntegrationsIntegrationTradedeskLazyRoute =
  DashboardLayoutIntegrationsIntegrationTradedeskLazyImport.update({
    path: '/tradedesk',
    getParentRoute: () => DashboardLayoutIntegrationsRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/dashboard/_layout/integrations/_integration/tradedesk.lazy'
    ).then((d) => d.Route),
  )

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexImport
      parentRoute: typeof rootRoute
    }
    '/dashboard': {
      id: '/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof DashboardRouteImport
      parentRoute: typeof rootRoute
    }
    '/$404': {
      id: '/$404'
      path: '/$404'
      fullPath: '/$404'
      preLoaderRoute: typeof R404Import
      parentRoute: typeof rootRoute
    }
    '/dashboard/_layout': {
      id: '/dashboard/_layout'
      path: ''
      fullPath: '/dashboard'
      preLoaderRoute: typeof DashboardLayoutImport
      parentRoute: typeof DashboardRouteImport
    }
    '/_auth/_authLayout': {
      id: '/_auth/_authLayout'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthAuthLayoutLazyImport
      parentRoute: typeof rootRoute
    }
    '/_auth/_authLayout/login': {
      id: '/_auth/_authLayout/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof AuthAuthLayoutLoginRouteImport
      parentRoute: typeof AuthAuthLayoutLazyImport
    }
    '/_auth/_authLayout/reset-password': {
      id: '/_auth/_authLayout/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof AuthAuthLayoutResetPasswordRouteImport
      parentRoute: typeof AuthAuthLayoutLazyImport
    }
    '/dashboard/_layout/integrations': {
      id: '/dashboard/_layout/integrations'
      path: '/integrations'
      fullPath: '/dashboard/integrations'
      preLoaderRoute: typeof DashboardLayoutIntegrationsRouteImport
      parentRoute: typeof DashboardLayoutImport
    }
    '/dashboard/_layout/$404': {
      id: '/dashboard/_layout/$404'
      path: '/$404'
      fullPath: '/dashboard/$404'
      preLoaderRoute: typeof DashboardLayout404Import
      parentRoute: typeof DashboardLayoutImport
    }
    '/_auth/_authLayout/forgot-password': {
      id: '/_auth/_authLayout/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof AuthAuthLayoutForgotPasswordRouteLazyImport
      parentRoute: typeof AuthAuthLayoutLazyImport
    }
    '/dashboard/_layout/settings': {
      id: '/dashboard/_layout/settings'
      path: '/settings'
      fullPath: '/dashboard/settings'
      preLoaderRoute: typeof DashboardLayoutSettingsRouteLazyImport
      parentRoute: typeof DashboardLayoutImport
    }
    '/dashboard/_layout/geopersona/map-view': {
      id: '/dashboard/_layout/geopersona/map-view'
      path: '/geopersona/map-view'
      fullPath: '/dashboard/geopersona/map-view'
      preLoaderRoute: typeof DashboardLayoutGeopersonaMapViewRouteImport
      parentRoute: typeof DashboardLayoutImport
    }
    '/dashboard/_layout/geopersona/segment-list': {
      id: '/dashboard/_layout/geopersona/segment-list'
      path: '/geopersona/segment-list'
      fullPath: '/dashboard/geopersona/segment-list'
      preLoaderRoute: typeof DashboardLayoutGeopersonaSegmentListRouteImport
      parentRoute: typeof DashboardLayoutImport
    }
    '/dashboard/_layout/places/map-view': {
      id: '/dashboard/_layout/places/map-view'
      path: '/places/map-view'
      fullPath: '/dashboard/places/map-view'
      preLoaderRoute: typeof DashboardLayoutPlacesMapViewRouteImport
      parentRoute: typeof DashboardLayoutImport
    }
    '/dashboard/_layout/integrations/users': {
      id: '/dashboard/_layout/integrations/users'
      path: '/users'
      fullPath: '/dashboard/integrations/users'
      preLoaderRoute: typeof DashboardLayoutIntegrationsUsersRouteLazyImport
      parentRoute: typeof DashboardLayoutIntegrationsRouteImport
    }
    '/dashboard/_layout/places/my-data': {
      id: '/dashboard/_layout/places/my-data'
      path: '/places/my-data'
      fullPath: '/dashboard/places/my-data'
      preLoaderRoute: typeof DashboardLayoutPlacesMyDataRouteLazyImport
      parentRoute: typeof DashboardLayoutImport
    }
    '/dashboard/_layout/integrations/': {
      id: '/dashboard/_layout/integrations/'
      path: '/'
      fullPath: '/dashboard/integrations/'
      preLoaderRoute: typeof DashboardLayoutIntegrationsIndexLazyImport
      parentRoute: typeof DashboardLayoutIntegrationsRouteImport
    }
    '/dashboard/_layout/integrations/_integration/tradedesk': {
      id: '/dashboard/_layout/integrations/_integration/tradedesk'
      path: '/tradedesk'
      fullPath: '/dashboard/integrations/tradedesk'
      preLoaderRoute: typeof DashboardLayoutIntegrationsIntegrationTradedeskLazyImport
      parentRoute: typeof DashboardLayoutIntegrationsRouteImport
    }
  }
}

// Create and export the route tree

export const routeTree = rootRoute.addChildren({
  IndexRoute,
  DashboardRouteRoute: DashboardRouteRoute.addChildren({
    DashboardLayoutRoute: DashboardLayoutRoute.addChildren({
      DashboardLayoutIntegrationsRouteRoute:
        DashboardLayoutIntegrationsRouteRoute.addChildren({
          DashboardLayoutIntegrationsUsersRouteLazyRoute,
          DashboardLayoutIntegrationsIndexLazyRoute,
          DashboardLayoutIntegrationsIntegrationTradedeskLazyRoute,
        }),
      DashboardLayout404Route,
      DashboardLayoutSettingsRouteLazyRoute,
      DashboardLayoutGeopersonaMapViewRouteRoute,
      DashboardLayoutGeopersonaSegmentListRouteRoute,
      DashboardLayoutPlacesMapViewRouteRoute,
      DashboardLayoutPlacesMyDataRouteLazyRoute,
    }),
  }),
  R404Route,
  AuthAuthLayoutLazyRoute: AuthAuthLayoutLazyRoute.addChildren({
    AuthAuthLayoutLoginRouteRoute,
    AuthAuthLayoutResetPasswordRouteRoute,
    AuthAuthLayoutForgotPasswordRouteLazyRoute,
  }),
})

/* prettier-ignore-end */

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/",
        "/dashboard",
        "/$404",
        "/_auth/_authLayout"
      ]
    },
    "/": {
      "filePath": "index.tsx"
    },
    "/dashboard": {
      "filePath": "dashboard/route.tsx",
      "children": [
        "/dashboard/_layout"
      ]
    },
    "/$404": {
      "filePath": "$404.tsx"
    },
    "/dashboard/_layout": {
      "filePath": "dashboard/_layout.tsx",
      "parent": "/dashboard",
      "children": [
        "/dashboard/_layout/integrations",
        "/dashboard/_layout/$404",
        "/dashboard/_layout/settings",
        "/dashboard/_layout/geopersona/map-view",
        "/dashboard/_layout/geopersona/segment-list",
        "/dashboard/_layout/places/map-view",
        "/dashboard/_layout/places/my-data"
      ]
    },
    "/_auth/_authLayout": {
      "filePath": "_auth/_authLayout.lazy.tsx",
      "children": [
        "/_auth/_authLayout/login",
        "/_auth/_authLayout/reset-password",
        "/_auth/_authLayout/forgot-password"
      ]
    },
    "/_auth/_authLayout/login": {
      "filePath": "_auth/_authLayout/login/route.tsx",
      "parent": "/_auth/_authLayout"
    },
    "/_auth/_authLayout/reset-password": {
      "filePath": "_auth/_authLayout/reset-password/route.tsx",
      "parent": "/_auth/_authLayout"
    },
    "/dashboard/_layout/integrations": {
      "filePath": "dashboard/_layout/integrations/route.tsx",
      "parent": "/dashboard/_layout",
      "children": [
        "/dashboard/_layout/integrations/users",
        "/dashboard/_layout/integrations/",
        "/dashboard/_layout/integrations/_integration/tradedesk"
      ]
    },
    "/dashboard/_layout/$404": {
      "filePath": "dashboard/_layout/$404.tsx",
      "parent": "/dashboard/_layout"
    },
    "/_auth/_authLayout/forgot-password": {
      "filePath": "_auth/_authLayout/forgot-password/route.lazy.tsx",
      "parent": "/_auth/_authLayout"
    },
    "/dashboard/_layout/settings": {
      "filePath": "dashboard/_layout/settings/route.lazy.tsx",
      "parent": "/dashboard/_layout"
    },
    "/dashboard/_layout/geopersona/map-view": {
      "filePath": "dashboard/_layout/geopersona/map-view/route.tsx",
      "parent": "/dashboard/_layout"
    },
    "/dashboard/_layout/geopersona/segment-list": {
      "filePath": "dashboard/_layout/geopersona/segment-list/route.tsx",
      "parent": "/dashboard/_layout"
    },
    "/dashboard/_layout/places/map-view": {
      "filePath": "dashboard/_layout/places/map-view/route.tsx",
      "parent": "/dashboard/_layout"
    },
    "/dashboard/_layout/integrations/users": {
      "filePath": "dashboard/_layout/integrations/users/route.lazy.tsx",
      "parent": "/dashboard/_layout/integrations"
    },
    "/dashboard/_layout/places/my-data": {
      "filePath": "dashboard/_layout/places/my-data/route.lazy.tsx",
      "parent": "/dashboard/_layout"
    },
    "/dashboard/_layout/integrations/": {
      "filePath": "dashboard/_layout/integrations/index.lazy.tsx",
      "parent": "/dashboard/_layout/integrations"
    },
    "/dashboard/_layout/integrations/_integration/tradedesk": {
      "filePath": "dashboard/_layout/integrations/_integration/tradedesk.lazy.tsx",
      "parent": "/dashboard/_layout/integrations"
    }
  }
}
ROUTE_MANIFEST_END */
